module.exports = __webpack_public_path__ + "static/img/login_icon.a16adaa6.png";